/**
 * userInfo模块接口列表
 */
import axios from './utils/https' // 导入http中创建的axios实例

const userInfo = {
  // 获取当前登录用户信息
  getCurrentUserInfo () {
    return axios.get('/api/userInfo/getCurrentUserInfo')
  },
  // 获取当前登录用户角色1、系统管理员  2、企业管理员  3、会议发起人  4、会议参与人
  getCurrentUserRole () {
    return axios.get('/api/userInfo/GetCurrentUserRole')
  },
  // 管理页面个人资料
  getManagerUserDetail () {
    return axios.get('/api/userInfo/GetManagerUserDetail')
  },
  editPersonalInfo (params) {
    return axios.post('/api/userInfo/editPersonalInfo', params)
  },
  // 管理页面用户列表
  getUserList (params) {
    return axios.get('/api/userInfo/GetUserList', { params })
  },
  // 获取用户信息（用户管理编辑）
  getUserInfo (params) {
    return axios.get('/api/userInfo/GetUserInfo', { params })
  },
  // 获取用户信息（用户管理编辑）
  editUserInfo (params) {
    return axios.post('/api/userInfo/EditUserInfo', params)
  },
  // 根据用户ID查询用户角色集合
  getUserRoleIds (params) {
    return axios.get('/api/userInfo/GetUserRoleIds', { params })
  },
  // 设置角色
  editUserRole (params) {
    return axios.post('/api/userInfo/EditUserRole', params)
  },
  // 重置用户密码
  resetUserPwd (params) {
    return axios.post('/api/userInfo/ResetUserPwd', params)
  },
  // 删除用户
  deleteUser (params) {
    return axios.delete('/api/userInfo/DeleteUser', { params })
  },
  // 删除用户（批量）
  batchDeleteUsers (params) {
    return axios.post('/api/userInfo/BatchDeleteUsers', params)
  }
}

export default userInfo
